import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import InnerModal from "./innerModal";

const Modal = props => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  });

  return ReactDOM.createPortal(
    <InnerModal {...props} />,
    document.querySelector("#modal")
  );
};
export default Modal;
